module.exports = __webpack_public_path__ + "img/emoji02.png";